import styled from 'styled-components';
import Image from '@stencil/image';
import {
  CenteredSpaceWrap,
  SmallSectionHeader,
} from '../../../../CommonStyleUtils/dwebCommon.styles';
import ArrowLeftDetailsOneIcon from '../../../../../Icons/ArrowLeftDetailsOneIcon';

export const CaptivateAllImageModalInnerWrap = styled.section(
  props => `
    display: flex;
    margin: 0 auto;
    justify-content:space-between;
  `,
);

export const RoundCircleWrapSpan = styled.span(
  props => `
    width:2rem;
    height:2rem;
    background-color:${props.theme.colors.goWhite.base};
    position:relative;
    align-items: center;
    border-radius:50%;
    margin-right:${props.theme.spacing.base};
`,
);

export const LeftArrowGalleryTraveller = styled(ArrowLeftDetailsOneIcon)(
  props => `
    width:1rem;
    height:1rem;
    fill:${props.theme.colors.downriver.base};
    position:absolute;
    top:0.5rem;
    right:0.5rem;
  `,
);

export const CaptivateLeftContainer = styled.div(
  props => `
    position:relative;
    margin-top: ${props.theme.spacing.custom(36)};
    // overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  `,
);

export const CaptivateHeaderText = styled(SmallSectionHeader)(
  props => `
    color:${props.theme.colors.goWhite.base};
    text-transform: capitalize;
  `,
);

export const CaptivateRightContainer = styled.div(
  props => `
    background:${props.theme.colors.goWhite.base};
    width: ${props.pokusShowDwebVideo ? '34%' : '30%'};
    overflow: scroll;
    height: 65rem;
    position:relative;
    &::-webkit-scrollbar {
      display: none;
    }
  `,
);

export const CaptivateRightTopWrap = styled.div(
  props => `
    position:sticky;
    top:0;
    background: ${props.theme.colors.goWhite.base};
    box-shadow: 0 5px 6px -6px ${props.theme.colors.downriver.light};
    padding: ${props.theme.spacing.custom(16)};
    h4{
      width: 80%;
    }
    z-index: ${props.theme.misc.zIndex.base};
    `,
);

export const CaptivateTaggedHeaderWrap = styled(CenteredSpaceWrap)(
  props => `
    margin-bottom: ${props.theme.spacing.custom(12)};
    margin-top: ${props.theme.spacing.base};
    background:${props.theme.colors.downriver.base};
    position: fixed;
    width: 68%;
    height: 3rem;
  `,
);

export const CaptivateHeaderWrap = styled(CenteredSpaceWrap)(
  props => `
    margin-bottom: ${props.theme.spacing.custom(12)};
    margin-top: ${props.theme.spacing.base};
  `,
);

export const CategoryOverviewBlock = styled.div(
  props => `
    margin-bottom: ${props.theme.spacing.custom(12)};
  `,
);

export const ViewMorePills = styled.div(
  props => `
    display:flex;
    align-items: center;
    cursor:pointer;
    color:${props.theme.colors.goWhite.base};
    font-weight: 600;
    font-size: ${props.theme.font.custom(14)};
    padding: ${props.theme.spacing.small} ${props.theme.spacing.custom(12)};
    background:${props.theme.colors.downriver.dark};
    border-radius:${props.theme.misc.borderRadius.custom(15.5)};
    margin-right: ${props.theme.spacing.large};
  `,
);

export const RadioButtonTabOuterWrapper = styled.div(
  props => `
    padding: ${props.theme.spacing.xsmall};
    margin-top:  ${props.theme.spacing.custom(16)};
    border: .1rem solid ${props.theme.colors.ash.dark};
    border-radius:${props.theme.misc.borderRadius.custom(26.5)};
      `,
);

export const RadioButtonTabWrapper = styled.div(
  props => `
    display: flex;
    position: relative;
    border-radius:${props.theme.misc.borderRadius.custom(46)};
    cursor: pointer;
    `,
);

export const RadioButtonTabInnerWrapper = styled.div(
  props => `
    width: 100%;
    cursor:pointer;
    `,
);

export const CarouselContainer = styled.div(
  props => `
    position: absolute;
    top:0;
    width: 70%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;

    `,
);

export const LeftOuterContainer = styled.div(
  props => `
    width: 68%;
    height: 65rem;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    ${props.pokusShowDwebVideo ? `margin-right:24px` : ``}
    `,
);

export const TotalNoGuestText = styled.div(
  props => `
  color:${props.theme.colors.downriver.light};
  font-size: ${props.theme.font.custom(10)};
    `,
);

export const RadioButtonTabSelected = styled.input(
  props => `
  position: absolute;
  opacity:0;
  & + label
  {
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
  padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(8)};
  border-radius:${props.theme.misc.borderRadius.custom(46)};
  font-size: ${props.theme.font.custom(14)};
  font-weight: 600;
  color:${props.theme.colors.ash.base};
  height:4.5rem;
  &.active {
      background-color:${props.theme.colors.goBrandBlue.base};
      color:${props.theme.colors.goWhite.base};
      cursor:pointer;
      }
  }

  &:checked + label {
  background: ${props.theme.colors.goBrandBlue.base};
  color:${props.theme.colors.goWhite.base};
  }

  &:checked + label >svg{
    fill:${props.theme.colors.goWhite.base};
  }

  &:checked + label>div>div{
    color:${props.theme.colors.goWhite.medium};
  }
`,
);

export const CaptivateImageCategoriesContainer = styled.div(
  props => `
    padding: ${props.theme.spacing.custom(16)} ${props.theme.spacing.custom(
      16,
    )} ${props.theme.spacing.custom(60)} ${props.theme.spacing.custom(16)};
    ${
      props.pokusShowDwebVideo
        ? `display:grid;
    grid-template-columns:repeat(2,1fr);
    gap:12px;`
        : ``
    }
    `,
);

export const CaptivateImageCategoriesCard = styled.div(
  props => `
    cursor:pointer;
    padding: ${props.theme.spacing.custom(16)};
    border: .1rem solid ${props.theme.colors.ash.dark};
    border-radius:${props.theme.misc.borderRadius.xlarge};
    margin-bottom:${props.theme.spacing.custom(12)};
    transtion: all 1s;
    &:last-child{
      margin-bottom:0;
    }

    &:hover{
      // border: .2rem solid ${props.theme.colors.goBrandBlue.base};
      transform: scale(1.03);
    }

    &.active{
      border: .2rem solid ${props.theme.colors.goBrandBlue.base};
    }
    `,
);

export const CaptivateImageCategoryLabel = styled.div(
  props => `
    font-weight: 600;
    font-size: ${props.pokusShowDwebVideo ? '14px' : props.theme.font.custom(16)};
    margin-bottom:${props.pokusShowDwebVideo ? '4px' : '0'}
    `,
);

export const CaptivateTotalImages = styled.div(
  props => `
    color:${props.theme.colors.downriver.medium};
    font-size: ${props.pokusShowDwebVideo ? '12px' : props.theme.font.custom(14)};
    `,
);

export const CaptivateCategoryImage = styled(Image)(
  props => `
    width:5rem;
    height:5rem;
    border-radius:${props.theme.misc.borderRadius.base};
    `,
);

export const CaptivateCategoryAllImageOne = styled(Image)(
  props => `
    width:3.2rem;
    height:3.2rem;
    border-radius:${props.theme.misc.borderRadius.base};
    margin-right:  ${props.theme.spacing.small};
    `,
);

export const CaptivateCategoryAllImageTwo = styled(Image)(
  props => `
    width:2rem;
    height:2rem;
    border-radius:${props.theme.misc.borderRadius.base};
    `,
);

export const CaptivateCategoryAllImagThree = styled(Image)(
  props => `
    display:flex;
    width:2.6rem;
    height:2.6rem;
    border-radius:${props.theme.misc.borderRadius.base};
    margin:  ${props.theme.spacing.custom(7)} auto 0;
    `,
);

export const ThumbImageWrapper = styled.div(
  props => `
    position: relative;
    margin-left:18px;
    >svg{
      position: absolute;
      left: 35%;
      top: 32%;
      height: 16px;
      width: 16px;
    }
    `,
);

export const CaptivateViewMore = styled.a(
  props => `
  cursor:pointer;
  font-weight: 600;
  font-size: 14px;
  color : #fff;
  display: flex;
  align-items : center;
  position : relative ;
  padding-right : 30px;
  &:hover{
    color:#fff;
  }
  &::after{
    position : absolute;
    content :  '';
    border: solid #fff;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  top : 1px;
  right : 7px;
  }
  `,
);
